import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HelpService } from './help-service/help.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EulaService } from './eula/eula.service';
import { ApiModule } from './api-service/api.module';
import { ApplicationService } from './application-service/application.service';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { StorageService } from './storage-service/storage.service';
import { ErrorNotificationService } from './error/error-notification.service';
import { OxeModelService } from './oxe-model-service/oxe-model.service';
import { LoggerService } from './logger-service/logger.service';
import { IndexedDBService } from './indexed-db-service/indexed-db.service';
import { SimpleNotificationsModule  } from 'angular2-notifications';
import { NotificationsService } from 'angular2-notifications';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { NgIdleModule } from '@ng-idle/core'; 


import {
  routing,
  appRoutingProviders
} from './app.routing';
import { LoginComponent } from './Login/login.component';
import { HomeModule } from './Home/home.module';
import { AuthenticationService } from './authentication-service/authentication.service';
import { DialogService } from './confirm-dialog/dialog.service';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { EulaComponent } from './eula/eula.component';
import { AuthGuard } from './guards/auth.guard';
import { ErrorHandler } from '@angular/core';
import { AppErrorHandler } from './app-error-handler';
import { EventService } from "./config-eventlogs/event.service";
import { ConfirmDialogExportComponent } from "./confirm-dialog-export/confirm-dialog-export.component";
import { DialogExportService } from "./confirm-dialog-export/export-dialog-service";
import { SelectDialogExportService } from "./select-dialog-export/select-dialog-export-service";
import { SelectDialogExportComponent } from "./select-dialog-export/select-dialog-export.component";


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConfirmDialogComponent,
    EulaComponent,
    ConfirmDialogExportComponent,
    SelectDialogExportComponent,
    
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SimpleNotificationsModule.forRoot(),
    TranslateModule.forRoot({
      loader:{
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [HttpClient]
      }
    }),
    NgIdleModule.forRoot(),
    routing,
    HomeModule,
    ApiModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    StorageService,
    IndexedDBService,
    LoggerService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    TranslateService,
    ApplicationService,
    OxeModelService,
    HelpService,
    JwtHelperService,
    EulaService,
    ErrorNotificationService,
    AuthenticationService,
    AuthGuard,
    appRoutingProviders,
    DialogService,
    DialogExportService,
    SelectDialogExportService,
    EventService,
    NotificationsService,
    {provide: ErrorHandler, useClass: AppErrorHandler}
  ],
  entryComponents: [AppComponent],
  bootstrap: [AppComponent]
})
export class AppModule {

}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}